import { useState, useEffect, useRef } from 'react';
import { useDrag } from 'react-dnd';
import Swal from 'sweetalert2';

const Cartao = ({ id, destacar, mensagemSistema, title, codigo, configuracao, esteiraID, showModal, percent, status, onShowPreview, onShowPdf, isContaConciliacaoInteligente, isBanco, isSalario, isFornecedor, secondTitle, processando, porcentagemProcessando, isTributo, etapaProcessamento, totalLancamentos, pendentesProcessamento, inicioProcessamento, usuarioProcessamento }: { id: number, title: String, secondTitle: string, configuracao: boolean, codigo: String, showModal: Function, percent: number | null, status: string, onShowPreview: Function, onShowPdf?: Function, isContaConciliacaoInteligente: boolean, isBanco: boolean, esteiraID: number, isSalario: boolean, mensagemSistema: any[], isFornecedor: boolean, destacar: boolean, processando: boolean, porcentagemProcessando: number, isTributo: boolean, etapaProcessamento?: string, totalLancamentos?: number, pendentesProcessamento?: number, inicioProcessamento?: string, usuarioProcessamento?: string }) => {

    const [{ opacity }, dragRef] = useDrag(() => ({
        type: 'CARD',
        item: { id, codigo, status, isContaConciliacaoInteligente, isBanco, isSalario, isFornecedor, configuracao, isTributo },
        collect: (monitor) => ({
            opacity: monitor.isDragging() ? 0.5 : 1,
        })
    }), []);

    const [loadingReport, setLoadingReport] = useState<boolean>(false);

    const isConciliando = status === 'Conciliando' || status === 'Em processamento' || processando;
    const showBar = status && status !== 'Pendentes';

    return (
        <div onClick={() => {
            showModal(codigo);
        }} ref={dragRef} style={{ opacity, width: '100%', height: 'auto', backgroundColor: '#EBECF0', padding: '10px 5px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'start', width: '100%', backgroundColor: destacar ? 'rgba(192, 57, 43, 0.1)' : 'white', borderRadius: '2px', padding: '5px' }}>




                {mensagemSistema && mensagemSistema.length > 0 && <div style={{ width: '50px', height: '5px', backgroundColor: 'red', borderRadius: '15px', marginBottom: '5px' }} />}
                <p style={{ fontSize: '14px', color: '#172b4d', margin: '0', textAlign: 'justify' }}>{codigo} - {title}</p>
                {loadingReport ? (
                    <div className="spinner-border text-success" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                ) : (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <i onClick={(e) => {
                            setLoadingReport(true);
                            e.stopPropagation();
                            onShowPreview(() => setLoadingReport(false));
                        }} className='fa fa-eye fs-4 mt-2' style={{ color: 'gray' }} />
                        {onShowPdf && (
                            <i onClick={(e) => {
                                setLoadingReport(true);
                                e.stopPropagation();
                                onShowPdf(() => setLoadingReport(false));
                            }} className='fa fa-file-pdf fs-4 mt-2' style={{ color: '#dc3545' }} title="Gerar PDF" />
                        )}
                        {percent !== null && percent !== undefined && (
                            <span style={{ marginLeft: '6px', fontSize: '12px', color: 'gray' }}>{percent}%</span>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

export default Cartao;
